















import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component({})
export default class Breadcrumbs extends Vue {
  @Prop(Array) items: { title: string; url: string }[];
  @Prop({ type: Boolean, default: false }) isSearchPage: boolean;
  @Prop({ default: false }) isMobile: boolean;

  get breadcrumbs() {
    return this.items.map((item) => ({
      text: item.title,
      to: { path: item.url },
    }));
  }
}
